import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress, Card, CardContent } from '@mui/material';
import { Line } from 'react-chartjs-2';
import axios from 'axios';

const BASE = 'https://education-backend.liara.run/api/report';

const ParentReportPage = () => {
  const { tokenOrId } = useParams(); // ما فعلاً از studentId یا توکن ساده استفاده می‌کنیم
  const [loading, setLoading] = useState(true);
  const [progress, setProgress] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [classRecords, setClassRecords] = useState([]);
  const studentId = Number(tokenOrId); // برای شروع اگر عدد بود، treat as id

  useEffect(() => {
    const fetchAll = async () => {
      setLoading(true);
      try {
        if (!Number.isNaN(studentId) && studentId > 0) {
          const [pRes, aRes, cRes] = await Promise.all([
            axios.get(`${BASE}/student/${studentId}/progress`),
            axios.get(`${BASE}/student/${studentId}/history`),
            axios.get(`https://education-backend.liara.run/api/class-records?studentId=${studentId}`)
          ]);
          setProgress(pRes.data || []);
          setAnswers(aRes.data || []);
          setClassRecords(cRes.data || []);
        } else {
          // اگر token استفاده بکنی، باید endpoint مخصوص والدین پیاده شود
          console.warn('شناسه معتبر نیست. پیاده‌سازی توکن نیاز به بک‌اند دارد.');
        }
      } catch (err) {
        console.error('❌ خطا در بارگذاری گزارش والدین:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [tokenOrId, studentId]);

  const chartData = {
    labels: progress.map((p) => p.date),
    datasets: [
      {
        label: 'درصد موفقیت',
        data: progress.map((p) => p.successRate),
        borderColor: '#1976d2',
        backgroundColor: '#1976d2',
        tension: 0.3,
        fill: false
      }
    ]
  };

  return (
    <Box sx={{ p: 3 }} dir="rtl">
      <Typography variant="h5" gutterBottom>گزارش وضعیت تحصیلی</Typography>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          <Typography variant="h6" sx={{ mt: 2 }}>نمودار پیشرفت</Typography>
          {progress.length === 0 ? (
            <Typography color="text.secondary">داده‌ای برای نمودار وجود ندارد.</Typography>
          ) : (
            <Line data={chartData} />
          )}

          <Typography variant="h6" sx={{ mt: 3 }}>تاریخچه پاسخ‌ها</Typography>
          {answers.length === 0 ? (
            <Typography color="text.secondary">هیچ پاسخی ثبت نشده.</Typography>
          ) : (
            answers.map((a, i) => (
              <Card key={i} sx={{ mt: 1 }}>
                <CardContent>
                  <Typography>سؤال: {a.questionText || a.QuestionText}</Typography>
                  <Typography>گزینه انتخاب‌شده: {a.selectedOption || a.SelectedOption}</Typography>
                  <Typography>امتیاز: {a.score ?? a.Score}</Typography>
                </CardContent>
              </Card>
            ))
          )}

          <Typography variant="h6" sx={{ mt: 3 }}>رکوردهای کلاس</Typography>
          {classRecords.length === 0 ? (
            <Typography color="text.secondary">رکوردی ثبت نشده.</Typography>
          ) : (
            classRecords.map((r) => (
              <Card key={r.id} sx={{ mt: 1 }}>
                <CardContent>
                  <Typography variant="subtitle2">{r.type} — {new Date(r.date).toLocaleDateString()}</Typography>
                  <Typography>{r.description}</Typography>
                  {r.score !== null && <Typography>نمره: {r.score}</Typography>}
                </CardContent>
              </Card>
            ))
          )}
        </>
      )}
    </Box>
  );
};

export default ParentReportPage;
